import React, { useMemo } from "react";
import FlightCard from "./FlightCard";
import { segmentCardsFromLegacyLegs } from "../flightProposalSummaryModel";

const isFlightProposalDebug =
  typeof import.meta !== "undefined" && import.meta.env && import.meta.env.DEV;

/**
 * כרטיס טיסה יחיד שמכיל את כל כיווני הטיסה (הלוך + חזור) יחד.
 * העטיפה ב־HrSection variant="hero" נעשית בעמוד האב.
 *
 * נתיבי רינדור:
 * - יש segmentCards מ־buildFlightSegmentCards → FlightCard (עיצוב מלא).
 * - אחרת יש legacyLegs (מבנה linked_flights פשוט) → ממופה ל־FlightCard דרך segmentCardsFromLegacyLegs.
 * - אחרת ריק.
 */
export default function FlightsCombinedBlock({ segmentCards, legacyLegs }) {
  const hasApiSegments = Array.isArray(segmentCards) && segmentCards.length > 0;

  const resolvedCards = useMemo(() => {
    if (hasApiSegments) return segmentCards;
    return segmentCardsFromLegacyLegs(legacyLegs || []);
  }, [hasApiSegments, segmentCards, legacyLegs]);

  const hasCards = resolvedCards.length > 0;
  const usedLegacyAdapter = !hasApiSegments && hasCards;

  return (
    <div className="hr-fp-flights-bundle" data-fp-render="FlightsCombinedBlock">
      {isFlightProposalDebug ? (
        <div
          className="hr-fp-render-debug"
          role="note"
          translate="no"
          style={{
            fontSize: 12,
            padding: "8px 10px",
            marginBottom: 10,
            background: "#fff9e6",
            border: "1px solid rgba(0,0,0,0.12)",
            borderRadius: 8,
            lineHeight: 1.45,
          }}
        >
          <strong>[DEV] Flight proposal — מסלול רינדור</strong>
          <div>קומפוננטה: FlightsCombinedBlock</div>
          <div>segmentCards (API/deal): {segmentCards?.length ?? 0}</div>
          <div>legacyLegs (גולמי): {legacyLegs?.length ?? 0}</div>
          <div>
            {hasCards
              ? `→ FlightCard × ${resolvedCards.length}${
                  usedLegacyAdapter ? " (ממופה מ־legacy)" : ""
                }`
              : "→ אין כרטיסים (empty)"}
          </div>
        </div>
      ) : null}

      {!hasCards ? (
        <div className="hr-fp-flights-bundle__empty">
          <p className="hr-order-tertiary">אין פירוט מקטעים בנתונים שנשמרו</p>
        </div>
      ) : null}

      {hasCards
        ? resolvedCards.map((block, i) => (
            <FlightCard
              key={block.segmentMeta?.id || `seg-${i}`}
              segmentMeta={block.segmentMeta}
              legTimelines={block.legTimelines}
              embedded={i > 0}
            />
          ))
        : null}
    </div>
  );
}
